import { cloudinaryVideo } from '../../config/cloudinaryVideos';

/** Solution tab clips — Cloudinary CDN with 1600px cap for faster loads. */
export let SOLUTION_VIDEO_SOURCES = {
  automation: cloudinaryVideo('8328106-uhd_2160_3840_25fps', 'solution'),
  chatbots: cloudinaryVideo('8464662-uhd_3840_2160_25fps', 'solution'),
  ml: cloudinaryVideo('8327799-uhd_3840_2160_25fps', 'solution'),
  strategy: cloudinaryVideo('7687810-uhd_4096_2160_24fps', 'solution'),
};

export const getSolutionVideoUrls = () => Object.values(SOLUTION_VIDEO_SOURCES);

export function hydrateSolutionVideos(sources) {
  if (sources && typeof sources === 'object' && Object.keys(sources).length) {
    SOLUTION_VIDEO_SOURCES = sources;
  }
}
